import { useContext } from "react";
import { LocaleContext } from "./LocaleContext";

interface LocaleContextValue {
  locale: string | undefined;

  setLocale: (_locale: string) => void;
}

/**
 * Hook for accessing locale context
 * @returns {Object} Locale state and setter
 * @returns {string | undefined} locale - Current locale
 * @returns {Function} setLocale - Function to set locale
 */
export function useLocale(): LocaleContextValue {
  const context = useContext(LocaleContext);

  if (!context) {
    throw new Error("useLocale must be used within LocaleProvider");
  }

  const { locale, setLocale } = context;
  return {
    locale,
    setLocale,
  };
}
